import { wizardActions, WizardMode, wizardSelectors } from './wizardSlice'
import PlansStep from './PlansStep'
import CheckoutStep from './CheckoutStep'
import ConfirmationStep from './ConfirmationStep'
import { store } from '../../redux/store'
import history from '../../routes/history'
import { cartSelectors, CartItemTypes } from '../Cart/cartSlice'
import { userSelectors } from '../../redux/userSlice'

export const wizardSteps = [
    {
        title: 'Select Plan',
        route: 'select-plan',
        component: PlansStep,
        stepsAfter: ['checkout', 'confirmation'],
    },
    {
        title: 'Checkout',
        route: 'checkout',
        component: CheckoutStep,
        stepsAfter: ['confirmation'],
    },
    {
        title: 'Confirmation',
        route: 'confirmation',
        component: ConfirmationStep,
        stepsAfter: [],
    },
]

const jsonSafeSteps = wizardSteps.map(step => ({
    id: step.route,
    title: step.title,
    stepsAfter: step.stepsAfter,
    done: false,
}))

export const getWizardStep = (steps, stepId) =>
    steps.find(step => step.id === stepId)

export const startWizard = ({ isUpgrade = false } = {}) => {
    const steps = [...jsonSafeSteps]
    const state = store.getState()
    const selectedPlan = cartSelectors.selectedPlan(state)
    const items = cartSelectors.cartItems(state)
    const mostRecentCourse = [...items]
        .reverse()
        .find(cartItem => cartItem.type === CartItemTypes.Course)
    const wizardState = {
        mode: isUpgrade ? WizardMode.UpgradePlan : WizardMode.NewUser,
        returnURL: '/app/dashboard',
        steps,
        currentStep: 'select-plan',
    }
    if (isUpgrade) {
        wizardState.returnURL = `/app/account/subscription`
    } else {
        if (selectedPlan) {
            const step = getWizardStep(wizardState.steps, 'select-plan')
            step.done = true
            wizardState.currentStep = 'checkout'
        }
        if (mostRecentCourse)
            wizardState.returnURL = `/app/browse/courses/${mostRecentCourse.id}`
    }
    store.dispatch(
        wizardActions.initializeWizard({
            ...wizardState,
        })
    )
    return `/app/wizard/${wizardState.currentStep}`
}

export const startUpgradePlanWizard = ({
    returnURL = `/app/account/subscription`,
}) => {
    const steps = [...jsonSafeSteps]
    const currentStep = getWizardStep(steps, 'select-plan').id
    store.dispatch(
        wizardActions.initializeWizard({
            mode: WizardMode.UpgradePlan,
            returnURL,
            steps,
            currentStep,
        })
    )
    history.push(`/app/wizard/${currentStep}`)
}

export const markCurrentWizardStepDone = () => {
    const state = store.getState()
    const { currentStep: currentStepId } = wizardSelectors.wizardState(state)
    store.dispatch(wizardActions.completeStep(currentStepId))
}

export const nextWizardStep = () => {
    const state = store.getState()
    const {
        steps,
        currentStep: currentStepId,
        returnURL,
    } = wizardSelectors.wizardState(state)
    const userRedirectURL = userSelectors.redirectUrl(state)
    markCurrentWizardStepDone()
    const currentStep = getWizardStep(steps, currentStepId)
    if (currentStep.stepsAfter.length > 0) {
        const nextStepId = currentStep.stepsAfter[0]
        store.dispatch(wizardActions.beginStep(nextStepId))
        history.push(`/app/wizard/${nextStepId}`)
    } else {
        // Prioritize the redirect URL from the user slice if present
        history.push(userRedirectURL ?? returnURL)
    }
}

export const jumpToWizardStep = stepId => {
    store.dispatch(wizardActions.beginStep(stepId))
    history.push(`/app/wizard/${stepId}`)
}

export const isWizardStepComplete = stepId => {
    const state = store.getState()
    const { steps, currentStep: currentStepId } = wizardSelectors.wizardState(
        state
    )
    const step = getWizardStep(steps, stepId)
    return currentStepId !== stepId && step.done
}
